<template>
  <layout-container>

    <template slot="left">
      <the-negotiations-form-button-accept-buyer-request v-if="areValuesPristine" @click="acceptRequest" />
    </template>

    <rbButton @click="cancel">Cancel</rbButton>

    <rb-button-with-material-icon :disabled="areValuesPristine" @click="submit" type="main">
      <template slot="icon">send</template>
      Submit Counteroffer
    </rb-button-with-material-icon>

  </layout-container>
</template>

<script>
  import TheNegotiationsFormButtonsMixin from './TheNegotiationsFormButtonsMixin.vue';
  import TheNegotiationsFormButtonAcceptBuyerRequest from './TheNegotiationsFormButtonAcceptBuyerRequest.vue';

  export default {

    name: 'negotiations-form-buttons-for-supplier-creating-response',

    mixins: [ TheNegotiationsFormButtonsMixin ],

    components: { TheNegotiationsFormButtonAcceptBuyerRequest }
  };
</script>
